import { QueryClientProvider } from '@showroomjs/bundles/query';
import { hydrate as hydrateFn, render as renderFn, } from 'react-showroom-compat';
import * as React from 'react';
import { basename, isPrerender } from '../lib/config';
import { createQueryClient } from '../lib/create-query-client';
import { BrowserRouter as Router } from '../lib/routing';
import { PreviewApp } from './preview-app';
const queryClient = createQueryClient();
const render = isPrerender ? hydrateFn : renderFn;
render(React.createElement(Router, { basename: `${basename}/_preview` },
    React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(PreviewApp, null))), document.getElementById('preview'));
//# sourceMappingURL=preview-client-entry.js.map